import { IN_PROGRESS } from './ProgressBar.types';

export const inProgress = payload => ({
  type: IN_PROGRESS,
  payload
});
